import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import PlatformBox from "../platform-box";
import HowToBg from "../../assets/images/how-to-contest.png";
import HowToMainImg from "../../assets/images/how-to-main-img.png";
import BzrpMainImg from "../../assets/images/biza-main-img.gif";

const sxStyles = {
  mainContainer: {
    backgroundImage: `url(${HowToBg})`,
    alignItems: "center",
    display: "flex",
    backgroundSize: "cover",
    justifyContent: "center",
    flexGrow: 1,
    overflow: "hidden",
    position: "relative",
    height: { xs: "510px", md: "700px" },
    width: { xs: "375px", md: "100%" },
  },
  staticCover: {
    backgroundSize: "cover",
    display: "flex",
    justifyContent: "center",
    flexGrow: 1,
    overflow: "hidden",
  },
  content: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    alignItems: "flex-start",
    justifyContent: "flex-end",
    width: "1440px",
    boxSizing: "border-box",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left",
    paddingTop: { xs: "70px", md: "190px" },
  },
  sectionText: {
    color: "white",
    fontSize: { xs: "16px", md: "24px" },
    fontFamily: "IBM Plex Sans",
    fontWeight: "400",
    lineHeight: { xs: "24px", md: "34px" },
    textAlign: "left",
    maxWidth: { xs: "355px", md: "100%" },
    paddingLeft: { xs: "20px", md: 0 },
  },
  p2Title: {
    color: "white",
    fontFamily: "p22-arts-and-crafts",
    fontSize: { xs: "32px", md: "45px" },
    fontWeight: "700",
    lineHeight: { xs: "33px", md: "70px" },
    marginRight: "13px",
    paddingBottom: "5px",
  },
  title: {
    color: "white",
    fontFamily: "IBM Plex Sans",
    fontSize: { xs: "36px", md: "45px" },
    fontWeight: "400",
    lineHeight: { xs: "37px", md: "65px" },
    marginRight: "13px",
  },
  secondTitle: {
    color: "#FDD925",
    fontFamily: "IBM Plex Sans",
    fontSize: { xs: "35px", md: "64px" },
    fontWeight: "700",
    lineHeight: { xs: "35px", md: "65px" },
    marginRight: "13px",
    marginBottom: "32px",
  },
};

const HowToContest = () => {
  return (
    <Stack sx={sxStyles.mainContainer}>
      <Stack
        sx={{
          display: "flex",
          marginTop: "20px",
          justifyContent: "center",
          alignItems: "center",
          width: { xs: "375px", md: "800px" },
          marginBottom: "40px",
        }}
      >
        <Grid
          sx={{
            display: "flex",
            marginTop: "20px",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Grid
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Typography sx={sxStyles.title}>1.</Typography>
            <Typography sx={sxStyles.title}>DESCARGÁ </Typography>
          </Grid>
          <Typography sx={sxStyles.p2Title}>BIZARRAPP</Typography>
        </Grid>
      </Stack>
      <Box
        sx={{
          display: "flex",
          width: { xs: "300px", md: "750px" },
          height: { xs: "180px", md: "335px" },
          backgroundImage: `url(${HowToMainImg})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          alignSelf: "center",
          justifySelf: "center",
        }}
      />
      <Stack
        sx={{
          position: "relative",
          paddingTop: { xs: "30px", md: "30px" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            paddingBottom: { xs: "20px", md: 0 },
            justifyContent: "center",
            marginTop: "-30px",
          }}
        >
          <PlatformBox />
        </Box>
      </Stack>
    </Stack>
  );
};

export default HowToContest;
